<template>
	<MoleculeHeaderSubBar
		v-if="!isSalesHeader"
		:layer="LayerEnum.Fit"
		:menu-social-items
		:menu-service-items
	/>
	<div
		data-testid="organism-fit-header-sticky"
		:data-test-hidden="isScrollingDown ? true : undefined"
		:class="[
			'sticky top-0 z-20 transition-transform duration-200',
			isScrollingDown ? '-translate-y-full' : 'translate-y-0',
		]"
	>
		<header class="bg-gradient-to-r from-purple-700 to-purple-900">
			<div
				class="container flex items-center flex-wrap gap-x-6 lg:gap-x-8 py-8 lg:py-0 min-h-32"
			>
				<button
					v-if="menuItems"
					class="lg:hidden z-10 w-10 flex flex-col mr-12"
					@click="clickMenuButton"
				>
					<span class="sr-only">Menu openen</span>
					<AtomFontAwesome
						icon="fa-bars"
						class="size-10 text-white"
					/>
				</button>
				<div
					class="flex items-center justify-center relative"
				>
					<AtomLink
						v-bind="homeLink"
						data-testid="organism-fit-header-logo"
						class="lg:h-28 flex items-center"
					>
						<AtomLogoFit class="h-14" />
					</AtomLink>
				</div>
				<LazyOrganismMainMenu
					v-if="!isSalesHeader && menuItems"
					class="hidden lg:flex xl:ml-12 text-white order-last xl:order-none basis-full xl:basis-auto rounded-full -mx-4"
					:menu-items="menuItems"
				/>
				<div
					class="hidden sm:flex items-center justify-end grow gap-4 lg:gap-8"
				>
					<div
						v-if="isSalesHeader"
						class="flex items-center gap-4 text-purple-200"
					>
						<AtomFontAwesome
							icon="fa-location-dot"
							class="w-8"
						/>
						<span>
							{{ streetName }} {{ streetNumber }} - {{ city }}
						</span>
					</div>
					<CallToActionButtons :is-sales-header="isSalesHeader" />
				</div>
			</div>
		</header>
	</div>
</template>

<script lang="ts" setup>
import CallToActionButtons from './CallToActionButtons.vue';
import { city, streetName, streetNumber } from '#base/core/consts/companyData';
import type { MenuItemType } from '#base/core/types/MenuItemType';
import type { SubHeaderMenuItemType } from '#base/core/types/SubHeaderMenuItemType';
import type { UrlType } from '#base/core/types/UrlType';
import { LayerEnum } from '#base/core/enums/LayerEnum';

defineProps<{
	menuSocialItems?: SubHeaderMenuItemType[];
	menuServiceItems?: SubHeaderMenuItemType[];
	menuItems?: MenuItemType[];
	phoneNumber: string;
	phoneLink: UrlType;
	homeLink: UrlType;
	isSalesHeader?: boolean;
}>();

const { isScrollingDown } = useScrollDirection();

const emit = defineEmits(['clickMenuButton', 'clickAppointmentButton']);

const clickMenuButton = () => emit('clickMenuButton');
</script>
